
// checkout popup Start
// var btnsDiv = document.querySelector('.product-form__buttons')
// //btnsDiv.classList.add('cursor-pointer')
// var atc = document.querySelector(".product-form__buttons button")
// //atc.classList.add('pointer-none')
// var bin = document.querySelector("dynamic-checkout shopify-payment-button__button")

// var qtyInp = document.querySelector('.quantity__input');
// qtyInp.addEventListener("change", function(e) {
//     var val = this.value
//     if(val <= 1){
//       //atc.classList.add('pointer-none')
//     } else {
//       //atc.classList.remove('pointer-none')
//     }
//     //console.log("val",val)
// })
// function showPop(e) {
//     if(qtyInp.value <= 1) {
//       openPopup()
//     }
//   }
//   //atc.addEventListener("click", showPop)
//   //bin.addEventListener("click", showPop)

// var qtyProducts = [7192461115588,7416739987652,7569820680388]

// async function getCartItems() {
//   var res = await fetch(window.Shopify.routes.root + 'cart.js')
//   .then(response => {
//     return response.json();
//   })
//   .catch((error) => {
//     console.error('Error:', error);
//   });
//   return res.items
// }

// var timesTried = 0

// var checkoutBtnModified = false

// function checkoutFlow() {
//   if(timesTried > 20) clearInterval(flowInterval)
//   timesTried++
//   var checkoutBtn = document.querySelector("#CartDrawer-Checkout")
//   if(checkoutBtn){
//     clearInterval(flowInterval)
//     checkoutBtnModified = true
//     checkoutBtn.classList.add('pointer-none')
//     var checkoutBtnHTML = checkoutBtn.outerHTML
    
//     var checkParent = document.createElement('div')
//     checkParent.classList.add('checkparent')
//     checkParent.insertAdjacentHTML('beforeend', checkoutBtnHTML);
//     console.log("added parent...")
//     new_html = "<div id='checkoutBtn-div'>" + checkoutBtnHTML + "</div>";
//     checkoutBtn.replaceWith(checkParent);
//     //checkoutBtn.parentNode.replaceChild(checkoutBtn, checkParent);
//     checkoutBtn.style.display = 'none'
//     checkParent.addEventListener("click", async function(e) {
//       var items = await getCartItems()
//       var showPop = false;
//       items.forEach((el) => {
//         if(qtyProducts.includes(el.product_id) && el.quantity == 1){
//           showPop = true
//         }
//       })
//       if(showPop){
//         var btn = document.querySelector('.popup span.button')
//         btn.innerText = "No, I am good - Check out"
//         btn.setAttribute('onclick','')
//         openPopup()
//         btn.addEventListener("click", () => {
//           checkoutBtn.click()
//           btn.innerText = "loading..."
//         })
//       } else {
//         checkParent.querySelector('button').innerText = 'loading...'
//         checkoutBtn.click()
//       }
//       console.log("items",items)
//     })
//   }
// }

// var flowInterval = setInterval(checkoutFlow,200)

// const open = window.XMLHttpRequest.prototype.open;
//   function openReplacement() { // patch XMLHTTP requests
//       this.addEventListener("load", async function () {
//           if (this._url.includes('cart/change') || this._url.includes('cart/add') || this._url.includes('cart/update') || this._url.includes('cart/clear')) {
//               console.log('xml cart changed...')
//             timesTried =  0
//               checkoutBtnModified = false
//             clearInterval(flowInterval)
//             flowInterval = setInterval(checkoutFlow,200)
//           }
//       });
//       return open.apply(this, arguments);
//   }
//   window.XMLHttpRequest.prototype.open = openReplacement;
// checkout popup End




// $(document).ready(function(){
//     $('.product .product__info-wrapper variant-radios fieldset .option label img').click(function(){
//         var src = $(this).attr('src');
//         console.log('Clicked image source:', src);

//       var Thumbnail = $("media-gallery .thumbnail-slider ul li button img");
//       // console.log('thumbnail:', Thumbnail);
//       Thumbnail.each(myFunction);
//       function myFunction(index, value) {
//         console.log(value.src);
//       }

//     });

// });

// $(document).ready(function(){
//     $('.product__image-thumbnail .thumbnail-list__item button img').click(function(){
//       alert($(this));
//       console.log($(this));
//       //   var src = $(this).attr('src');
//       //   console.log('Clicked image source-k:', src);
//     });

// });

// $(document).ready(function(){
//   console.log('kmk');
//     $('media-gallery .thumbnail-slider ul li button img').click(function(){
//       alert('1');
//       console.log('kmk');
//   });
// });


// $(document).ready(function(){
//     $('.product .product__info-wrapper .variant-radios fieldset .option label img').click(function(){
//         var src = $(this).attr('src');
//         console.log('Clicked image source:', src);

//         $("media-gallery .thumbnail-slider ul li button img").each(function(index, item) {
//             console.log($(item).attr('src'));
//         });
//     });
// });



// $(document).ready(function(){
//     $('.product .product__info-wrapper variant-radios fieldset .option label img').click(function(){
//         var src = $(this).attr('src');
//         var imageName = src.split('/').pop(); // Extracting the image name from the URL
//         console.log('Clicked image name:', imageName);

//         var Thumbnail = $("media-gallery .thumbnail-slider ul li button img");
//         Thumbnail.each(function(index, value) {
//             var thumbnailSrc = value.src;
//             var thumbnailImageName = thumbnailSrc.split('/').pop(); // Extracting the image name from the thumbnail URL
//             console.log(thumbnailImageName);
//             if (imageName === thumbnailImageName) {
//                 console.log("Image names matched.");
//                 // Do something here if the image names match
//             } else {
//                 console.log("Image names did not match.");
//                 // Do something else if the image names don't match
//             }
//         });
//     });
// });


// $(document).ready(function(){
//     $('.product .product__info-wrapper variant-radios fieldset .option label img').click(function(){
//         var src = $(this).attr('src');
//         console.log('Clicked image source:', src);

//         var Thumbnail = $("media-gallery .thumbnail-slider ul li button img");
//         Thumbnail.each(function(index, value) {
//             console.log(value.src);
//             if (value.src.includes(src)) {
//                 console.log("Clicked image source is contained in the thumbnail source.");
//                 // Do something here if the clicked image source is contained in the thumbnail source
//             } else {
//                 console.log("Clicked image source is not contained in the thumbnail source.");
//                 // Do something else if the clicked image source is not contained in the thumbnail source
//             }
//         });
//     });
// });

// $(".product-form__buttons #bundle-button").on('click', function () { 
//   // alert('clicked');
//   lineItemAddtocart();
// });



// Product page - Care Guide Pop up Script
$(document).ready(function(){
  $(".product-popup-modal__opener .product-popup-modal__button").click(function(){
     $("modal-dialog.product-popup-modal").attr("open", "");
  });
});


// Free Product
// Get the variant ID input element
let getInput = document.querySelector('.gift-product-wrapper .gift-product-variant-id');

// Debounce utility to limit the number of times manageFreeProduct can be triggered
// function debounce(func, delay) {
//   let debounceTimer;
//   return function() {
//     clearTimeout(debounceTimer);
//     debounceTimer = setTimeout(() => func.apply(this, arguments), delay);
//   };
// }

// Function to add an item to the cart
function addItemToCart() {
  let c = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  let sections = c.getSectionsToRender().map((section) => section.id);

  let formData = {
    'items': [{
      'id': getInput.value,
      'quantity': 1
    }],
    'sections': sections
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(res => res.json())
  .then(cart => {
    // console.log(cart, '-Gift Cart Data');

    if (cart.items.length) {
      cart.items[0].sections = cart.sections;
      c.renderContents(cart.items[0]);
      if (c.classList.contains('is-empty')) c.classList.remove('is-empty');
      throwConfettiEffects();
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

// Function to remove an item from the cart without refreshing
function removeItemFromCart() {

  let c = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  let sections = c.getSectionsToRender().map((section) => section.id);

  let updates = {
    'id': getInput.value,
    'quantity': 0,
     'sections': sections
  };

  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(updates)
  })
  .then(res => res.json())
  .then(cart => {
    // if (cart.items.length) {
    //   cart.items[0].sections = cart.sections;
    //   c.renderContents(cart.items[0]);
    //   if (c.classList.contains('is-empty')) c.classList.remove('is-empty');
    // }

    if (cart.items.length === 0) {
      c.classList.add('is-empty');
      c.renderContents({ sections: cart.sections });
    } else {
      cart.items[0].sections = cart.sections;
      c.renderContents(cart.items[0]);
      if (c.classList.contains('is-empty')) c.classList.remove('is-empty');
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

// // Function to manage adding/removing the free product
// function manageFreeProduct() {
//   $.getJSON('/cart.js', function(cart) {
//     // Exclude the free product to get the correct item count
//     let itemCountWithoutFreeProduct = cart.items
//       .filter(item => item.id != getInput.value) // Exclude free product
//       .reduce((total, item) => total + item.quantity, 0); // Sum up quantities

//     let hasFreeProduct = cart.items.some(item => item.id == getInput.value);

//     // Check conditions based on the adjusted item count
//     if (itemCountWithoutFreeProduct >= 5 && !hasFreeProduct) {
//       addItemToCart(); // Add free product if conditions are met

// // throwConfettiEffects();

//     } else if ((itemCountWithoutFreeProduct < 5 || itemCountWithoutFreeProduct == 0) && hasFreeProduct) {
//       removeItemFromCart(); // Remove free product if conditions are not met
//     }
//   });
// }


// function throwConfettiEffects(){
// // setTimeout(() => {
//   confetti({
//       particleCount: 100,
//       spread: 70,
//       origin: { y: 0.6 }
//   });
// // }, 2000);
// } 

function throwConfettiEffects() {
    // Find the position of the target element
    const targetElement = document.querySelector('#CartDrawer .drawer__inner');
    const rect = targetElement.getBoundingClientRect();

    // Convert element's position to confetti origin coordinates
    const originX = (rect.left + rect.width / 2) / window.innerWidth;
    const originY = (rect.top + rect.height / 5) / window.innerHeight;
    console.log('originX',originX);
    console.log('originX',originY);

    // Trigger the confetti effect with custom origin
    confetti({
        particleCount: 100,
        spread: 30,
        origin: { x: originX, y: originY },
        colors: ["#ab6145", "#2a262f", "#585777", "#f6d9b0", "#723921"],  // Optional: use your color array
        zIndex: 999999999
    });
}




// Function to manage adding/removing the free product
function manageFreeProduct(cart) {
  let freeCount = getInput.dataset.count;
  // $.getJSON('/cart.js', function(cart) {
    // Exclude the free product to get the correct item count
    // let itemCountWithoutFreeProduct = cart.items
    //   .filter(item => item.id != getInput.value) // Exclude free product
    //   .reduce((total, item) => total + item.quantity, 0); // Sum up quantities

  console.log('cart',cart);

  // Example usage:
  fetchCartItemsWithoutHideBundle()
  .then((hasNonHiddenBundleItem) => {
    // console.log("Promise resolved with value:", hasNonHiddenBundleItem);

    let itemCountWithoutFreeProduct = cart.items
    .filter(item => item.id != getInput.value && hasNonHiddenBundleItem) // Exclude free product and items with "hideBundle" tag
    .reduce((total, item) => total + item.quantity, 0);

    console.log('itemCountWithoutFreeProduct',itemCountWithoutFreeProduct)

    let hasFreeProduct = cart.items.some(item => item.id == getInput.value);

    // Check conditions based on the adjusted item count
    if (itemCountWithoutFreeProduct >= freeCount && !hasFreeProduct) {
      addItemToCart(); // Add free product if conditions are met
    } else if ((itemCountWithoutFreeProduct < freeCount || itemCountWithoutFreeProduct == 0) && hasFreeProduct) {
      removeItemFromCart(); // Remove free product if conditions are not met
    }
    
  })
  .catch((error) => {
    console.error("Error occurred:", error);  // Handles any error
  });
    
  // });

}

async function fetchCartItemsWithoutHideBundle() {
  try {
    // Fetch the cart data
    const cartResponse = await fetch('/cart.js');
    if (!cartResponse.ok) throw new Error('Failed to fetch cart data');

    const cartData = await cartResponse.json();

    // Fetch each product by its handle and check for the "hideBundle" tag
    const itemsWithoutHideBundle = await Promise.all(
      cartData.items.map(async (item) => {
        // Fetch product data by handle
        const productResponse = await fetch(`/products/${item.handle}.js`);
        if (!productResponse.ok) throw new Error(`Failed to fetch product data for ${item.handle}`);
        
        const productData = await productResponse.json();

        // Check if "hideBundle" tag is present in the product's tags
        const hasHideBundleTag = productData.tags.includes("hideBundle");

        // Return item if it does not contain the "hideBundle" tag
        return !hasHideBundleTag ? item : null;
      })
    );

    // Filter out null values, leaving only items without the "hideBundle" tag
    const validItems = itemsWithoutHideBundle.filter(item => item !== null);

    // Check if there's at least one item without the "hideBundle" tag
    const hasNonHiddenBundleItem = validItems.length > 0;
    
    return hasNonHiddenBundleItem;
  } catch (error) {
    console.error("Error fetching cart or product data:", error);
  }
}


// Debounced version of manageFreeProduct to prevent multiple calls
// const debouncedManageFreeProduct = debounce(manageFreeProduct, 300);

// Initial check on document ready
// debouncedManageFreeProduct();

// Listen for cart update events and re-check item count
// document.addEventListener("cart:change", debouncedManageFreeProduct);


document.addEventListener("add:product:cart", function (event) {
  fetchCartData();
});


async function fetchCartData() {
  try {
    // Fetch cart JSON data from Shopify
    const response = await fetch('/cart.js');
    
    // Check if the response is OK
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const cartData = await response.json();
    // console.log('Cart Data:', cartData);
    manageFreeProduct(cartData);
    
  } catch (error) {
    console.error('Error fetching cart data:', error);
  }
}




// recommended product
$(document).ready(function(){
  function RecommendedProduct() {
    $(".recommended-product .addtocartnovariant").on("click", function() {
      // alert('1');
      let getProductID = $(this).attr('product-id');
      // alert(getProductID);
      let c = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      let sections = c.getSectionsToRender().map((section) => section.id);
  
  
      let formData = {
        'items': [{
          'id': getProductID,
          'quantity': 1
        }],
        'sections': sections
      };
    
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(res => res.json())
      .then(cart => { 
        if (cart.items.length) {
          cart.items[0].sections = cart.sections;
          c.renderContents(cart.items[0]);
          if (c.classList.contains('is-empty')) c.classList.remove('is-empty');
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    });
  }

  // Initial check on document ready
  RecommendedProduct();
  
  // Listen for cart update events and re-check
  document.addEventListener("cart:change", RecommendedProduct);
  
});


$(document).ready(function() {
  function ClosePopup() {
    $(document).on('click', '.product-variant-popup .close-icon svg', function() {
      $('#product-variant-popup').html("");
      $('#product-variant-popup').hide();
      // console.log('Closed by clicking the icon');
    });
  
    // Close the popup when clicking outside the popup-box
    $('#product-variant-popup').click(function(event) {
      if (!$(event.target).closest('.popup-box').length) {
        $('#product-variant-popup').html("");
        $('#product-variant-popup').hide();
        // console.log('Closed by clicking outside the popup-box');
      }
    });
  }

  // Initial check on document ready
  ClosePopup();
  
  // Listen for cart update events and re-check
  document.addEventListener("cart:change", ClosePopup);
});


document.addEventListener("DOMContentLoaded", function () {
  function getCookie(name) {
    let nameEQ = name + "=";
    let cookiesArray = document.cookie.split(';');
    
    for (let i = 0; i < cookiesArray.length; i++) {
      let cookie = cookiesArray[i].trim();
      if (cookie.indexOf(nameEQ) == 0) {
        return cookie.substring(nameEQ.length, cookie.length);
      }
    }
    return null; // Cookie not found
  }
  
  function cartDrawerUpsell() {
    requestAnimationFrame(() => {
      let drawerUpsellTag = document.querySelector('cart-drawer cart-drawer-items tbody tr[upsell_tag="true"]');
      let drawerUpsellproduct = document.querySelector('cart-drawer cart-drawer-items tbody tr[upsell_product="true"]');
  
      if (drawerUpsellTag) {
        let upsellPopup = document.querySelector(".upsell-popup-product.upsell-product");
        
        if (drawerUpsellproduct) {
          upsellPopup.style.display = "none";
          return;
        }
        
        if (upsellPopup) {
          setTimeout(() => {
            upsellPopup.style.display = "block";
          }, 1500)
          
        }
      }
    });
  }

  function cartUpsell() {
    requestAnimationFrame(() => {
      let drawerUpsellTag = document.querySelector('cart-drawer cart-drawer-items tbody tr[upsell_tag="true"]');
      let drawerUpsellproduct = document.querySelector('cart-drawer cart-drawer-items tbody tr[upsell_product="true"]');
      let productRemoved = getCookie('product_removed');
       console.log("If Outside")
      if (drawerUpsellTag) {
        let upsellPopup = document.querySelector(".upsell-popup-product.upsell-product");
        if (drawerUpsellproduct) {
          upsellPopup.style.display = "none";
          return;
        }
        if (upsellPopup && !productRemoved) {
          setTimeout(() => {
            upsellPopup.style.display = "block";
          }, 1500)
        }
      }
    });
  }
  
  const handleUpsellClick = () => {
    document.cookie = "product_removed=true; path=/"; 
  };
  
  const removeProductRemovedCookie = () => {
    document.cookie = "product_removed=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  };
  // Remove Cookie When page Loading
  window.addEventListener('beforeunload', removeProductRemovedCookie);

  $(document).click(function(e){
     var click=$(e.target);
     var outsideDiv=$(".popup-product").parents();
     if(click.is(outsideDiv)){
       $(".upsell-popup-product.upsell-product").css("display", "none"); 
       handleUpsellClick();
     }
  });
  
  $('.upsell-popup-product.upsell-product svg.close-icon').on("click", function() {
    $('.upsell-popup-product.upsell-product').css('display','none');
    handleUpsellClick();
  });
  
  $('.upsell-popup-product.upsell-product .upsell-cancle-button').on("click", function() {
    $('.upsell-popup-product.upsell-product').css('display','none');
    handleUpsellClick();
  });
  
 
  
  
  document.addEventListener("add:variants:cart", (e) => {
    let submit_btn= document.querySelector('.product-form__buttons button[type="submit"]');
    if(submit_btn?.getAttribute('data-upsell')){
      cartDrawerUpsell();
    }
  });
  document.addEventListener("bundle:upsell:cart", (e) => {
    let submit_btn= document.querySelector('.product-form__buttons button[type="submit"]');
    if(submit_btn?.getAttribute('data-upsell')){
      cartDrawerUpsell();
    }
   });
  document.addEventListener("bundle:add:cart", (e) => {
    let submit_btn= document.querySelector('.product-form__buttons button[type="submit"]');
    if(submit_btn?.getAttribute('data-upsell')){
      cartDrawerUpsell();
    }
  });
  
  // document.addEventListener("cart:change", (e) => {
  //   let subMitBtn= document.querySelector('.product-form__buttons button[type="submit"]');
  //   if(subMitBtn.getAttribute('data-upsell')){
  //     cartUpsell();
  //    }
  // }); 
  
  document.addEventListener("cart:item:change", (e) => {
  let drawerUpsellproduct = document.querySelector('cart-drawer cart-drawer-items tbody tr[upsell_product="true"]');
  let qty_btn = e.detail;
  let parentElement = qty_btn;
    while (parentElement) {
      if (parentElement.classList.contains('cart-item') && parentElement.getAttribute('upsell_tag') === 'true') {
          break;
      }
      parentElement = parentElement.parentElement;
    }

    if(parentElement?.getAttribute('upsell_tag')){
      let productRemoved = getCookie('product_removed');
      if(!productRemoved){
         cartUpsell();
      }
    }
  }); 


  // $('.upsell-popup-product.upsell-product').on("click", function() {
  //   $('.upsell-popup-product.upsell-product').css('display','none');
  // });

  // $('.upsell-popup-product.upsell-product .svg.close-icon').on("click", function() {
  //   $('.upsell-popup-product.upsell-product').css('display','none');
  // });
  
});